import { render, staticRenderFns } from "./DeleteVhostDialog.vue?vue&type=template&id=49d2d33d&"
import script from "./DeleteVhostDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteVhostDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports